import React, { Component } from 'react'
import css from './styles.scss'
import ModifiersEditor from '../ModifiersEditor'

export class ChoiceFromDataSourceColumnEditor extends Component {
  constructor ({ variable }) {
    super()
    this.state = {
      selectedDataSource: variable.args[0] || '',
      selectedColumn: variable.args[1] || 0,
      columnNameIsReference: variable.args[2] || false
    }
    this.acceptableMacros = ['javascript', 'choiceFromDataSourceColumn', 'choiceFromDataSourceColumnName', 'getter']
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { selectedDataSource, selectedColumn, columnNameIsReference } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [selectedDataSource, selectedColumn, columnNameIsReference])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  handleUpdateSelectedDataSource = evt => {
    this.setState({
      selectedDataSource: evt.target.value
    })
    this.setState({
      selectedColumn: ''
    })
  }

  handleUpdateSelectedColumn = evt => {
    const selected = evt.target.value
    this.setState({
      selectedColumn: selected
    })
  }

  toggleColumnNameIsReference = () => {
    const columnNameIsReference = !this.state.columnNameIsReference
    this.setState({
      columnNameIsReference: columnNameIsReference,
      selectedColumn: ''
    })
  }

  generateDataSourceOptions = () => {
    const { dataSources } = this.props
    const options = [<option key='0' value=''>Select Data Source...</option>]
    let index = 1
    for (const dataSourceId in dataSources) { // eslint-disable-line no-unused-vars
      if (dataSources.hasOwnProperty(dataSourceId)) { // eslint-disable-line no-prototype-builtins
        options.push(<option key={`_${index}`} value={dataSourceId}>{dataSources[dataSourceId].name}</option>)
        index++
      }
    }
    return options
  }

  generateDSColumnOptions = () => {
    const { selectedDataSource } = this.state
    const { dataSources } = this.props
    if (selectedDataSource === '' || !dataSources[selectedDataSource]) {
      return []
    }
    const options = []
    if (selectedDataSource.length) {
      const columnNames = dataSources[selectedDataSource].columns
      let index = 0
      options.push(<option key={`_${index}`} value=''>Random Column</option>)
      index++
      for (const name of columnNames) { // eslint-disable-line no-unused-vars
        options.push(<option key={`_${index}`} value={name}>{name}</option>)
        index++
      }
    }
    return options
  }

  generateVariableOptions = () => {
    const { selectedDataSource } = this.state
    const { vars, variableName } = this.props
    if (selectedDataSource === '') {
      return []
    }
    const options = [<option value='' key='EMPTY_OPTION'>Select Variable...</option>]
    Object.keys(vars).forEach(varName => {
      if (variableName !== varName) {
        const variableDetails = vars[varName]
        if (this.acceptableMacros.indexOf(variableDetails.macro) > -1) {
          options.push(
            <option value={varName} key={varName}>{variableDetails.name}</option>
          )
        }
      }
    })
    return options
  }

  generateColumnSourceSwitch = () => {
    const { columnNameIsReference } = this.state
    if (columnNameIsReference) {
      return (
        <span className={css.switch}>
          <button onClick={() => this.toggleColumnNameIsReference()} className={css.switchBtn}>
            Use Data Source Column
          </button>
        </span>
      )
    }
    return (
      <span className={css.switch}>
        <button onClick={() => this.toggleColumnNameIsReference()} className={css.switchBtn}>
          Use a Variable
        </button>
      </span>
    )
  }

  render () {
    const dataSourceOptions = this.generateDataSourceOptions()
    const columnOptions = this.generateDSColumnOptions()
    const variableOptions = this.generateVariableOptions()
    const columnSourceSwitch = this.generateColumnSourceSwitch()
    const { modifiers, instance, instanceModifiers } = this.props

    let instanceInput = null
    if (instance) {
      instanceInput = <ModifiersEditor instanceModifiers={instanceModifiers} isInstance />
    }

    return (
      <div style={{ marginTop: '10px' }}>
        <label>Data Source</label>
        <div className={css.backer}>
          <select
            className={css.select}
            value={this.state.selectedDataSource}
            onChange={this.handleUpdateSelectedDataSource}
          >
            {dataSourceOptions}
          </select>
        </div>
        {columnSourceSwitch}
        <div style={this.state.columnNameIsReference ? { display: 'none' } : {}}>
          <label>Select a Data Source Column</label>
          <div className={css.backer}>
            <select
              className={css.select}
              value={this.state.selectedColumn}
              onChange={this.handleUpdateSelectedColumn}
            >
              {columnOptions}
            </select>
          </div>
        </div>
        <div style={this.state.columnNameIsReference ? {} : { display: 'none' }}>
          <label>Select a Data Source Column</label>
          <div className={css.backer}>
            <select
              className={css.select}
              value={this.state.selectedColumn}
              onChange={this.handleUpdateSelectedColumn}
            >
              {variableOptions}
            </select>
          </div>
        </div>
        <ModifiersEditor modifiers={modifiers} />
        {instanceInput}
      </div>
    )
  }
}
export default ChoiceFromDataSourceColumnEditor



// WEBPACK FOOTER //
// /app/js/components/EditVariable/ChoiceFromDataSourceColumnEditor/index.js